import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modal: { overflowY: 'auto' },
  paper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '70%',
    maxWidth: 1200,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  icon: {
    margin: 'auto',
    fontSize: 65,
    position: 'absolute',
    backgroundColor: theme.palette.type === 'dark' ? '#121212' : '#7f7f7f',
    padding: 10,
    borderRadius: '50%',
    top: -30,
    color: theme.palette.primary.dark,
    left: 'calc(50% - 32.5px)'
  },
  tableRoot: {
    marginTop: 20,
    [theme.breakpoints.down('sm')]: {
      marginTop: 30
    }
  }
}))
export default useStyles
